import { render, staticRenderFns } from "./digital-shelf-light.vue?vue&type=template&id=87fc9738"
import script from "./digital-shelf-light.vue?vue&type=script&lang=js"
export * from "./digital-shelf-light.vue?vue&type=script&lang=js"
import style0 from "../core/icons.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./digital-shelf-light.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports